import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { DeviceLogsColumn } from "../DevicesModule/DeviceLogsColumn";
import { DeviceCategoriesFilter } from "../DevicesModule/DeviceCategoriesFilter";
import { DeviceDevicesFilter } from "../DevicesModule/DeviceDevicesFilter";
import { DeviceLogsTypeStatusUserFilters } from "./DeviceLogsTypeStatusUserFilters";
import { devicesActions, locationActions } from "../_actions";
import { ContentSpace, MainPageWithButtons } from "../_components";
import { Selectors } from "../_reducers/app.reducer";
import { CapsuleButton } from '../_components/CapsuleButton';
import { IsoStartEndDatePicker } from '../_components/IsoStartEndDatePicker';
import { Icons } from "../_assets";
import { deviceLogsActions } from '../_actions/deviceLogs.actions';


export function DeviceLogsModule() {
    
    //LIBRARIES
    const { t } = useTranslation();
    const dispatch = useDispatch();

    //GLOBAL STATE
    const filterMode                = useSelector(Selectors.getDeviceFilterFilterMode);
    const categories                = useSelector(Selectors.getDeviceFilterCategories);
    
    const markedDevice              = useSelector(Selectors.getMarkedDevice);
    const devices                   = useSelector(Selectors.getSelectedLocationDevices);
    const rooms                     = useSelector(Selectors.getRooms);
    const locationUid               = useSelector(Selectors.getSelectedLocationUid);
    const timezone                  = useSelector(Selectors.getTimezone);
    const { begin, end }            = useSelector(Selectors.getDeviceLogsDateFilter);
    const handleRefreshLogs         = () => dispatch(deviceLogsActions.getDeviceLogsFirstPage());
    const handleStartDate           = (date) => dispatch(deviceLogsActions.setFilterDateBegin(date));
    const handleEndDate             = (date) => dispatch(deviceLogsActions.setFilterDateEnd(date));


    //INITIALIZATION
    useEffect(() => {
        dispatch(devicesActions.initializeDevices(
            markedDevice,
            filterMode,
            devices,
            rooms,
        ));
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, locationUid]);

    useEffect(() => {
        dispatch(locationActions.getLocationUsers(locationUid));
    }, [dispatch, locationUid]);

    //UPDATES
    useEffect(() => {
        dispatch(devicesActions.showDevicesOfSelectedCategories(
            devices,
            categories,
            filterMode,
        ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, categories]);

    return (
        <ContentSpace
            mainContent={
                <MainPageWithButtons
                    size={'UNLIMITED'}
                    pageTitle={t("logs.logs")}
                    content={logsContent()}
                    buttons={[<CapsuleButton
                        icon={Icons.refresh}
                        onClick={handleRefreshLogs}
                    />]}
                />
            }
        />
    );

    function logsContent() {
        return (
            <div
                className="h-100 d-flex flex-column"
                style={{ gap: 12 }}
            >
                <div
                    className="d-flex flex-wrap align-items-center"
                    style={{ gap: 12 }}
                >
                    <IsoStartEndDatePicker
                        startIsoDate={begin}
                        endIsoDate={end}
                        handleStartDateChange={handleStartDate}
                        handleEndDateChange={handleEndDate}
                        timezone={timezone}
                        compact
                    />
                    <DeviceCategoriesFilter />
                    <DeviceDevicesFilter />
                    <DeviceLogsTypeStatusUserFilters />
                </div>
                <div style={{ flex: '1 1 auto', minHeight: 0 }}>
                    <DeviceLogsColumn />
                </div>
            </div>
        );
    }

    
}